<template>
  <div v-if="isDesktop">
    <video muted playsinline preload="metadata" class="questionnaire-slider__video">
      <source :src="src" type="video/mp4" />
    </video>
  </div>
</template>

<script>
import { BREAKPOINTS } from '~scripts/core/breakpoints';

export default {
  props: {
    src: String,
  },
  data() {
    return {
      isDesktop: false,
    };
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaSm() {
      return window.matchMedia(`(max-width: ${this.breakpoints.smMax})`);
    },
  },
  mounted() {
    this.mediaSm.addListener(this.handleMediaChange);
    this.handleMediaChange(this.mediaSm);
  },
  methods: {
    handleMediaChange(event) {
      this.isDesktop = !event.matches;
    },
  },
};
</script>
